import { render, staticRenderFns } from "./ShipReview.vue?vue&type=template&id=5bbc814e&scoped=true&"
import script from "./ShipReview.vue?vue&type=script&lang=js&"
export * from "./ShipReview.vue?vue&type=script&lang=js&"
import style0 from "./ShipReview.vue?vue&type=style&index=0&id=5bbc814e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc814e",
  null
  
)

export default component.exports